export default __webpack_public_path__ + "static/media/fifa.c85439ba.svg";